import { Wording } from '@/types';

export const MEDITATION_WORDING_DE: Wording = {
  components_header_media_content: 'Audios',
  components_header_media_1: 'Meditationen',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Anleitungen',
  components_header_text2: 'Der Blog',
  components_header_members: 'Mitglieder',
  hero_text: 'Wo Meditation auf die Sterne trifft',
  hero_button_text: 'Beginnen Sie Ihre Reise nach innen',
  components_ressources_section_title: 'RESSOURCEN',
  components_ressources_subheader_text: 'Werkzeuge für inneren Frieden, Erdung und alltägliche Balance',
  components_ressources_span_text: 'Öffnen Sie die Tür zur inneren Ruhe mit unseren ausgewählten Meditationen und Anleitungen. Finden Sie Klarheit, finden Sie wieder zu Ihrem Atem und stimmen Sie sich auf Ihren inneren Rhythmus ein – einen achtsamen Moment nach dem anderen.',
  components_ressources_card_1_title: 'Spiegelung',
  components_ressources_card_1_text: 'Kurze Meditationen und Audioreflexionen, um Ihre Gedanken zu zentrieren und sich wieder auf Ihren kosmischen Rhythmus auszurichten.',
  components_ressources_card_2_title: 'Erkunde die Tiefen',
  components_ressources_card_2_text: 'Gehen Sie mit umfassenden Anleitungen, die Meditation, Astrologie und Selbsterforschung für eine dauerhafte Transformation kombinieren, unter die Oberfläche.',
  components_ressources_link: 'Mehr anzeigen',
  components_notes_and_google_title_1: 'Seelenvolle Führung',
  components_notes_and_google_title_2: 'Achtsame Rituale',
  components_notes_and_google_title_3: 'Geführte Meditationen',
  components_review_google_text: 'Google Bewertungen',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Unsere Meditationen',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Mehr entdecken',
  text2_section_title: 'Ratgeber',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'LEITFADEN',
  components_text1_subheader_text: 'Kosmisches Wissen für die tägliche Ausrichtung',
  components_text1_span_text: 'Richten Sie sich nach den Rhythmen des Universums: Erkunden Sie eine kuratierte Sammlung ausführlicher astrologischer und meditativer Anleitungen, die innere Klarheit wecken, das Selbstbewusstsein vertiefen und Sie auf Ihrer Reise zu seelenvollem, himmlischem Wachstum unterstützen sollen.',
  components_text1_card_1_title: 'Offen für die Stille',
  components_text1_card_1_text: 'Beginnen Sie Ihre Reise mit grundlegenden Meditations- und Astrologieführern – ideal für Suchende, die sich zu innerer Ruhe, kosmischen Mustern und persönlichen Erkenntnissen hingezogen fühlen.',
  components_text1_card_3_title: 'Geist-Körper-Verbindung',
  components_text1_card_3_text: 'Entdecken Sie die tieferen Schichten Ihrer inneren Welt. Diese Anleitungen gehen über die Oberfläche hinaus und enthüllen Bedeutung, Emotionen und bewusste Muster, die Ihr Erleben prägen.',
  components_text1_card_2_title: 'Reflektieren und Integrieren',
  components_text1_card_2_text: 'Von emotionalen Blockaden bis hin zu Planetenzyklen – diese Leitfäden bieten Werkzeuge zur Reflexion, Heilung und Transformation durch achtsame Rituale und astrologische Weisheit.',
  components_text1_link: 'Alle Anleitungen anzeigen',
  components_footer_text: 'Erwache im Inneren: Deine Stille, Deine Stärke',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Registrierungsnummer',
  components_footer_legal: 'Rechtliches',
  components_footer_terms: 'Geschäftsbedingungen',
  components_footer_privacy: 'Datenschutzrichtlinie',
  button_load_more: 'Mehr laden',
  page_media_1_content_hero_text: 'Meditationen',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Achtsamkeit',
  page_media_content_menu_energyboost: 'Energieschub',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Anleitungen',
  page_text1_section_title: 'Anleitungen',
  page_text1_subheader_text: 'Unsere Guides',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um fortzufahren',
  enter_email_placeholder_email: 'E-Mail',
  enter_email_button_enter: 'Eingeben',
  components_login_success_text: 'Erfolgreich angemeldet!',
  components_card_link_media_content: 'Jetzt anhören',
  components_card_link_text1_content: 'Leitfaden anzeigen',
  components_card_link_text2_content: 'Erkunden',
  france: 'Frankreich',
  cyprus: 'Zypern',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditation',
  page_media_content_menu_all: 'Alle',
};